import { consolo } from '../composables/consolo'

type Funcion = (...args: unknown[]) => void

const EmisorEventosObjeto: {
  _events: Record<string, Funcion[]>
  on: (evento: string, callback: Funcion) => void
  once: (evento: string, callback: Funcion) => void
  off: (evento: string, callback: Funcion) => void
  offAll: (evento?: string) => void
  listeners: (evento: string) => Funcion[]
  emit: (evento: string, ...args: unknown[]) => void
} = {
  _events: {},
  on(name: string, listener: Funcion) {
    if (!this._events[name])
      this._events[name] = []
    this._events[name].push(listener)
  },
  once(name: string, listener: Funcion) {
    const onceWrapper = (...args: unknown[]) => {
      listener(...args)
      this.off(name, onceWrapper)
    }
    this.on(name, onceWrapper)
  },

  off(name: string, listenerToRemove: Funcion) {
    if (!this._events[name]) {
      consolo.warn(`Evento "${name}" no existe.`)
      return
    }
    const filterListeners = (l: Funcion) => l !== listenerToRemove
    this._events[name] = this._events[name].filter(filterListeners)
    // Si no quedan listeners, dejamos un array vacío para evitar delete dinámico
    if (this._events[name].length === 0) {
      this._events[name] = []
    }
  },

  offAll(name?: string) {
    if (!name) {
      // Reiniciar el mapa completo sin usar delete dinámico
      this._events = {}
      return
    }
    if (!this._events[name])
      return
    this._events[name] = []
  },

  listeners(name: string) {
    return this._events[name] ? [...this._events[name]] : []
  },

  emit(name: string, ...args: unknown[]) {
    const suscritos = this._events[name]
    if (!suscritos || suscritos.length === 0) {
      consolo.info(`Evento "${name}", no tiene suscritos.`)
      return
    }
    suscritos.forEach((callback: Funcion) => {
      callback(...args)
    })
  }
}

export default EmisorEventosObjeto
